"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("../../authenticated.client");
class CategoryClientV2 extends authenticated_client_1.AuthenticatedClient {
    getAll(projectId, catalogId, search) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/catalogs/${catalogId}/categories?${this.getQueryString(search)}`);
            return response.payload || [];
        });
    }
    search(projectId, catalogId, request) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/catalogs/${catalogId}/categories`, request);
            return response.payload || [];
        });
    }
    downloadCsv(projectId, catalogId, request) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/catalogs/${catalogId}/categories/export`;
            return this.executeRaw('post', url, request);
        });
    }
}
exports.CategoryClientV2 = CategoryClientV2;
//# sourceMappingURL=category.v2.client.js.map